import Input from "@/ui/input";
import { IconComponent } from "@/ui/icon";
import GradientBorderRadius from "@/ui/gradient-border-radius";
import WalletsFiltersModal from "@/features/filters-modals/wallets-filters-modal";
import { useWalletDiscoveryFilter } from "@providers/wallet-discovery-filter/wallet-discovery-filter-provider.tsx";

import AddWalletModal from "@/features/add-wallet-modal/add-wallet-modal";
import { PauseAll } from "@/features/copy-trade-controls/pause-all";
import { UnpauseAll } from "@/features/copy-trade-controls/unpause-all";
import WalletSelector from "@/features/copy-trade-controls/wallet-selector";
import { useWeb3Auth } from "@web3auth/modal-react-hooks";

const CopyTradeHeader = ({
  isAllSelected,
  setIsAllSelected,
}: {
  isAllSelected: boolean;
  setIsAllSelected: (value: boolean) => void;
}) => {
  const { isConnected } = useWeb3Auth();

  const { searchWallet, onSearchWalletUpdate } = useWalletDiscoveryFilter();

  return (
    <div className="relative w-full flex justify-between items-center px-[0.625rem]">
      <div className="flex justify-center items-center gap-[0.3125rem]">
        <WalletSelector
          isAllSelected={isAllSelected}
          setIsAllSelected={setIsAllSelected}
          hasAll={true}
        />
        <div className="flex justify-center items-center gap-[0.3125rem]">
          <div className=" h-[1.45rem]  w-[25rem] group">
            <Input
              className="pl-[0.25rem] font-semibold group placeholder:text-white"
              placeholder="Wallet"
              value={searchWallet ?? ""}
              onChange={(value) => onSearchWalletUpdate(value)}
              rightSide={
                <GradientBorderRadius
                  radius="left"
                  gradient={
                    searchWallet && searchWallet !== ""
                      ? "reversed-100"
                      : "default-border"
                  }
                  hover="input-50-right"
                >
                  <div className="w-[1.375rem] h-[1.375rem] flex justify-center items-center">
                    <IconComponent
                      name="search"
                      className="w-[0.75rem] h-[0.75rem]"
                    />
                  </div>
                </GradientBorderRadius>
              }
            />
          </div>
        </div>
      </div>
      <div className="absolute inset-0 flex justify-center items-center pointer-events-none">
        <div className="text-base leading-[0.625rem] font-semibold">
          Copy Trade
        </div>
      </div>
      <div className="flex justify-center items-center gap-[0.3125rem]">
        <AddWalletModal isConnected={isConnected} />
        <PauseAll isConnected={isConnected} />
        <UnpauseAll isConnected={isConnected} />
        <WalletsFiltersModal />
      </div>
    </div>
  );
};

export default CopyTradeHeader;
